import './blog-entry.scss';
import '../../shared/cta/cta';
import './components/blog-card';
import { appendText, appendRichTextToElement, getText, setImage } from '../../../assets/js/text-renderer';

const COMPONENTS = {
  DIVIDER: 'block-blog-divider',
  IMAGE: 'block-blog-image',
  QUOTE: 'block-blog-quote',
  TEXT: 'block-blog-text',
};

const CLASSES = {
  FIRST_ELEMENT: 'mb-4',
  OTHER_ELEMENTS: 'my-4',
  QUOTE: 'quote',
  QUOTE_AUTHOR: 'quote-author',
  QUOTE_AUTHOR_INFO: 'quote-author-info',
};

document.addEventListener('DOMContentLoaded', async () => {
  if (DEVELOPMENT) {
    const queryParams = new URLSearchParams(window.location.search);
    const entryKey = queryParams.get('key');

    await render(entryKey);
  } else if (window['__PRERENDER_INJECTED'] && window['__PRERENDER_INJECTED'].render_text) {
    const url = window.location.pathname;
    const entryKey = url.replace('/blog/', '').replace('/index.html', '');

    await render(entryKey);
  }
});

const render = async (entryKey) => {
  const data = await getText(`blog/blog-entries/${entryKey}`);
  setHero(data.stories[0].content);
  setEntry(data.stories[0].content.sections);

  ['keywords', 'content', 'cta'].forEach((detail) => {
    window.dispatchEvent(new CustomEvent('rendered-text', { detail }));
  });
};

const setHero = ({ header_title, header_description, author, date, header_image }) => {
  appendText(header_title, 'blog-entry-header-title');
  appendText(header_description, 'blog-entry-header-title-description');
  appendText(author, 'blog-entry-author');
  appendText(date, 'blog-entry-date');
  setImage(header_image, 'blog-entry-header-image');
};

const setEntry = (sections) => {
  const entryContent = document.getElementById('blog-entry-content');

  sections.forEach((section, index) => {
    const isFirstElement = index === 0;
    const classToAdd = isFirstElement ? CLASSES.FIRST_ELEMENT : CLASSES.OTHER_ELEMENTS;

    switch (section.component) {
      case COMPONENTS.TEXT:
        createTextSection(section.text, classToAdd, entryContent);
        break;
      case COMPONENTS.IMAGE:
        createImageSection(section.image, section.image_caption, classToAdd, entryContent);
        break;
      case COMPONENTS.DIVIDER:
        createDivider(entryContent);
        break;
      case COMPONENTS.QUOTE:
        createQuoteSection(section.quote_content, section.quote_author, classToAdd, entryContent);
        break;
      default:
        // Handle unknown component types if necessary
        break;
    }
  });
};

const createTextSection = (text, classToAdd, parent) => {
  const newSection = document.createElement('section');
  newSection.classList.add(classToAdd);
  appendRichTextToElement(text, newSection);
  parent.appendChild(newSection);
};

const createImageSection = (image, caption, classToAdd, parent) => {
  if (!image.filename) return;

  if (caption) {
    const figure = document.createElement('figure');
    figure.classList.add(classToAdd);
    const img = document.createElement('img');
    img.src = image.filename;
    img.alt = caption;
    const figcaption = document.createElement('figcaption');
    figcaption.textContent = caption;
    figure.appendChild(img);
    figure.appendChild(figcaption);
    parent.appendChild(figure);
  } else {
    const img = document.createElement('img');
    img.classList.add(classToAdd);
    img.src = image.filename;
    parent.appendChild(img);
  }
};

const createDivider = (parent) => {
  const hr = document.createElement('hr');
  parent.appendChild(hr);
};

const createQuoteSection = (quoteText, authorName, classToAdd, parent) => {
  if (!quoteText || !authorName) return;

  const blockquote = document.createElement('blockquote');
  blockquote.classList.add(classToAdd, CLASSES.QUOTE);

  const p = document.createElement('p');
  p.textContent = quoteText;
  blockquote.appendChild(p);

  const quoteAuthorDiv = document.createElement('div');
  quoteAuthorDiv.classList.add(CLASSES.QUOTE_AUTHOR);

  const quoteAuthorInfoDiv = document.createElement('div');
  quoteAuthorInfoDiv.classList.add(CLASSES.QUOTE_AUTHOR_INFO);

  const strong = document.createElement('strong');
  strong.textContent = authorName;
  quoteAuthorInfoDiv.appendChild(strong);

  quoteAuthorDiv.appendChild(quoteAuthorInfoDiv);
  blockquote.appendChild(quoteAuthorDiv);

  parent.appendChild(blockquote);
};
